import {Program, Texture, Mesh} from '../../beam/index';
import settings from '../settings'
import forwardPBRShader from '../shaders/pbr-forward-fs.glsl';
import deferedPBRShader from '../shaders/pbr-defered-fs.glsl';

import PBRVS from '../shaders/pbr-vs.glsl';
import AlphaVS from '../shaders/alpha-vs.glsl';
import AlphaFS from '../shaders/alpha-fs.glsl';


var defaultTexture;
var sharedMeshMaterial
let sharedAlphaMaterial;
let sharedInstancingMaterial;
var PROGRAM_CACHE  = {}
var CACHE_TEXTURE  = {}

let numTexturesLoaded = 0
let numTexturesToLoad = 0
let HDList = []
function onALLSDTexturesLoaded() {
    HDList.forEach( (a )=>{
        a.img.onload = ()=>{
            a.img.onload = null
            a.texture.bindImage( a.img );
        }
        a.img.src = a.src.replace(/32x32/, a.textureResolution)
    } ) 
    HDList = []
}


function createTexture(gl,src, mipmap, textureResolution) {
    if  ( !CACHE_TEXTURE[src] ) {
        numTexturesToLoad++
        let texture = new Texture(gl, {
            linear:     true, 
            mipmap:     mipmap, 
            miplinear:  mipmap,
            flipY:      false,
            wrapS:      gl.REPEAT,
            wrapT:      gl.REPEAT,
            anisotropy: 0,
        })
        let img = new Image()
        img.crossOrigin = "";
        img.onload = ()=>{
            img.onload = null
            img.onerror = null
            texture.bindImage(img);
            numTexturesLoaded++
            if ( /32x32/.test(src) ) {
                HDList.push( {texture, src,img, textureResolution} )
            }
            if (numTexturesLoaded >= numTexturesToLoad) {
                onALLSDTexturesLoaded()
            }
        }
        img.onerror = ()=>{
            img.onload = null
            img.onerror = null
            numTexturesLoaded++
            if (numTexturesLoaded >= numTexturesToLoad) {
                onALLSDTexturesLoaded()
            }
        }
        img.src = src;
        CACHE_TEXTURE[src] = texture
    } 

    return CACHE_TEXTURE[src];
}


export function clearCache() {
    defaultTexture = null;
    // sharedMeshMaterial = null;
    // sharedAlphaMaterial = null;
    // sharedInstancingMaterial = null;
    // PROGRAM_CACHE  = {}
    CACHE_TEXTURE  = {}
    numTexturesLoaded = 0
    numTexturesToLoad = 0
    HDList = []
}


export default function buildMesh(gl, options, loader) {

    if (!gl) {
        console.warn('buildMesh() missing gl context')
        return;
    }

    options  =  Object.assign({}, {
        beforeRender:      ()=>{},
        onLoaded:          ()=>{},
        type:              "mesh",
        tiling: [1,1],
        json:              null,
        depthTest:         true,
        blend:             false,
        alpha:             1,
        refraction:        0,
        color:             [0, 0, 1],
        shadows:           true,
        billboard:         false,
        lightMap:          false,
        normalScale:       [1,1],
        fresnel:           false,
        roughness:         0.5,
        metalness:         0,
        shadowColor:       [0,0,0],
        friction:          1,
        gravity:           0,
        uScale:            1,
        specularIntensity: 1,
        tint:              [1,1,1],
        desaturation:      0,
        id:                null,
        skin:              null,
        emissiveIntensity: 1,
        stripes: false,
        emissiveColor: [0,0,0],
        textureResolution: "2048",
        useReflectionProbe: false,
        useKeeing: false,

    }, options);

    defaultTexture = defaultTexture || new Texture(gl);

    let meshMaterial;
    
    let mesh = {}

    mesh.blend = options.blend

    mesh.id = options.id;

    mesh._uniforms = { 
        
        tShadowMap:          defaultTexture,
        tShadow:             defaultTexture,
        tAlbedo:             defaultTexture,
        tLightMap:           defaultTexture,
        tMetalness:          defaultTexture,
        tMetallicRoughness:  defaultTexture,
        tORM:                defaultTexture,
        tAlphaMap:           defaultTexture,
        tNormal:             defaultTexture,
        tRoughness:          defaultTexture,
        tDepth:              defaultTexture,
        tBackDepth:          defaultTexture,
        tRayMarch:           defaultTexture,
        tEquirectangularMap: defaultTexture,
        tAOMap:              defaultTexture,
        tEmissive:           defaultTexture,

        useTitle: 0,
        tTitle: defaultTexture,

        useStripes:         options.stripes?1:0,
        uEmissiveIntensity: 0,
        isEmissiveTexture: 0,
        uEmissiveColor:     options.emissiveColor,
        uScale:             options.scale,
        uRoughness:         options.roughness,
        uMetalness:         options.metalness,
        uAlpha:             options.alpha,
        uRefraction:        options.refraction,
        uColor:             options.color,
        uBillboard:         options.billboard?1:0,
        // useShadows:         options.shadows?1:0,
        useNormalMap:       0,
        useRoughnessMap:    0,
        useTransmitenceMap: 0,
        useAlbedoMap:       0,
        useLightMap:        0,
        useAOMap:           0,
        useAlphaMap:        0,
        useReflectionProbe:  0,
        useKeeing: 0,
        useEnvMap:          0,
        useFresnel:         options.fresnel?1:0,
        useMetalnessMap:    0,
        useMetallicRoughnessMap: 0,
        useORMMap:   0,
        uShadowColor: options.shadowColor,
        uSpecularIntensity: options.specularIntensity,
        useOcclusionMap: 0,
        useDislaceMap: 0,
        uTint: options.tint,
        uDesaturation: options.desaturation,
        uRandomColor: [1, 1, 0],

        uTiling: options.tiling,

    }
        
    if (options.displaceMap) {
        mesh._uniforms.useDislaceMap = 1
        mesh._uniforms.tDisplace = options.displaceMap;
    }
    else {
        mesh._uniforms.useDislaceMap = 0
    }
    
    mesh._uniforms.useReflectionProbe = options.useReflectionProbe ? 1 : 0
    mesh._uniforms.useKeeing = options.useKeeing ? 1 : 0

    if (options.normalMap || options.normalBuffer) {
        mesh._uniforms.useNormalMap = 1
        mesh._uniforms.tNormal = options.normalBuffer ? options.normalBuffer : createTexture(gl, options.normalMap, options.mipmap, options.textureResolution )
        mesh._uniforms.uNormalScale = options.normalScale
    }
    else {
        mesh._uniforms.useNormalMap = 0
    }

    if (options.occlusionMap) {
        mesh._uniforms.useOcclusionMap = 1
        mesh._uniforms.tOcclusion = createTexture(gl, options.occlusionMap,options.mipmap, options.textureResolution )
    }
    else {
        mesh._uniforms.useOcclusionMap = 0
    }
    if (options.albedoMap) {
        mesh._uniforms.useAlbedoMap = 1
        mesh._uniforms.tAlbedo = createTexture(gl, options.albedoMap,options.mipmap, options.textureResolution )
    }
    else {
        mesh._uniforms.useAlbedoMap = 0
    }
    
    if (options.lightMap) {
        mesh._uniforms.useLightMap = 1
        mesh._uniforms.tLightMap = createTexture(gl, options.lightMap,options.mipmap, options.textureResolution )
    }

    mesh._uniforms.uEmissiveIntensity = options.emissiveIntensity
    mesh._uniforms.uEmissiveColor     = options.emissiveColor
    
    if (options.emissiveMap && typeof options.emissiveMap == 'string') {
        mesh._uniforms.isEmissiveTexture = 1
        mesh._uniforms.useEmissiveMap = 1
        mesh._uniforms.tEmissive = createTexture(gl, options.emissiveMap,options.mipmap, options.textureResolution )
    }
    else {
        mesh._uniforms.isEmissiveTexture = 0
        mesh._uniforms.useEmissiveMap = 0
        mesh._uniforms.tEmissive = null;
    }

    if (options.aoMap) {
        mesh._uniforms.useAOMap = 1
        mesh._uniforms.tAOMap = createTexture(gl, options.aoMap,options.mipmap, options.textureResolution )
    }
    else {
        mesh._uniforms.useAOMap = 0
    }
    if (options.alphaMap) {
        mesh._uniforms.useAlphaMap = 1
        mesh._uniforms.tAlpha = createTexture(gl, options.alphaMap,options.mipmap, options.textureResolution )
    }
    else {
        mesh._uniforms.useAlphaMap = 0
    }

    
    if (options.transmitenceMap) {
        mesh._uniforms.useTransmitenceMap = 1
        mesh._uniforms.tTransmitence = createTexture(gl, options.transmitenceMap,options.mipmap, options.textureResolution )
    }
    else {
        mesh._uniforms.useTransmitenceMap = 0
    }

    if (options.roughnessMap) {
        mesh._uniforms.useRoughnessMap = 1
        mesh._uniforms.tRoughness = createTexture(gl, options.roughnessMap,options.mipmap, options.textureResolution )
    }
    else {
        mesh._uniforms.useRoughnessMap = 0
    }
    if (options.metalnessMap) {
        mesh._uniforms.useMetalnessMap = 1
        mesh._uniforms.tMetalness = createTexture(gl, options.metalnessMap,options.mipmap, options.textureResolution )
    }
    else {
        mesh._uniforms.useMetalnessMap = 0
    }
    if (options.ORMMap) {
        mesh._uniforms.useORMMap = 1
        mesh._uniforms.tORM = createTexture(gl, options.ORMMap,options.mipmap, options.textureResolution )
    }
    else {
        mesh._uniforms.useORMMap = 0
    }


    


    if (options.skin) {
        mesh._uniforms.useSkin = 1;
        let numJoints = options.skin.joints.length 
        PROGRAM_CACHE[ numJoints ] = PROGRAM_CACHE[ numJoints ] || new Program(gl,{
            vertexShader:    PBRVS,
            fragmentShader:  /*options.blend ? AlphaFS : */settings.forwardRendering ? forwardPBRShader : deferedPBRShader,
            depthTest:       true,
            defines:         {
                HAS_SKIN: 1,
                MAX_JOINTS: numJoints//16 because mat4
            }
        });
        meshMaterial = PROGRAM_CACHE[ numJoints ]
    }
    else {
        let defines = {}
        if (settings.deferedRendering) defines.DEFERED_RENDERING = 1
        if (settings.forwardRendering) defines.FORWARD_RENDERING = 1
        if (settings.useDerivative)    defines.USE_DERIVATIVE = 1
        
        if (options.blend) {
            if (options.instancing) {
                defines.USE_INSTANCING = 1
            }



            meshMaterial = new Program(gl,{
                vertexShader:    AlphaVS,
                fragmentShader:  AlphaFS,
                blend: true,
                depthTest: false,
                blendSrcRGB  : gl.SRC_ALPHA,
                blendDstRGB  : gl.ONE_MINUS_SRC_ALPHA,
                blendSrcAlpha: gl.ONE,
                blendDstAlpha: gl.ONE_MINUS_SRC_ALPHA,
                defines
            });
            meshMaterial.name = 'sharedAlphaMaterial'
        }
        //seperate instacing material because of the USE_INSTANCING define
        else if (options.instancing) {


            defines.USE_INSTANCING = 1
            sharedInstancingMaterial = sharedInstancingMaterial || new Program(gl,{
                vertexShader:    PBRVS,
                fragmentShader:  settings.forwardRendering ? forwardPBRShader : deferedPBRShader,
                depthTest:       true,
                defines
            });
            sharedInstancingMaterial.name = 'sharedInstancingMaterial'
            meshMaterial = sharedInstancingMaterial
        }
        else {
            sharedMeshMaterial = sharedMeshMaterial || new Program(gl,{
                vertexShader:    PBRVS,
                fragmentShader:  settings.forwardRendering ? forwardPBRShader : deferedPBRShader,
                depthTest:       true,
                defines
            });
            sharedMeshMaterial.name = 'sharedMeshMaterial'
            meshMaterial = sharedMeshMaterial
        }

    }

    mesh.material = meshMaterial
    
    return mesh;
}